import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, PhoneIcon, FileTextIcon, ScaleIcon, BellIcon } from 'lucide-react';
const topics = [{
  id: 1,
  icon: PhoneIcon,
  title: 'Probleme zilnice',
  description: 'Apeluri, contracte, clienți – orice situație operațională care necesită clarificare sau asistență imediată.'
}, {
  id: 2,
  icon: FileTextIcon,
  title: 'Întrebări despre proceduri',
  description: 'Traininguri, acces platformă, proceduri interne – tot ce ține de procesele agenției și cum să le aplici corect.'
}, {
  id: 3,
  icon: ScaleIcon,
  title: 'Situații juridice, fiscale sau tehnice',
  description: 'Cazuri complexe care necesită expertiza departamentelor specializate – legal, fiscal, tehnic.'
}, {
  id: 4,
  icon: BellIcon,
  title: 'Anunțuri personale',
  description: 'Absențe obligatorii, concedii, situații care afectează disponibilitatea ta – comunicarea este esențială.'
}];
export function SupportAccordion() {
  const [expandedId, setExpandedId] = useState<number | null>(null);
  return <div className="space-y-3" data-id="element-6765">
      {topics.map((topic, index) => <motion.div key={topic.id} initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.4,
      delay: index * 0.1
    }} data-id="element-6766">
          <button onClick={() => setExpandedId(expandedId === topic.id ? null : topic.id)} className="w-full bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all text-left border-2 border-transparent hover:border-[#357BEB]" data-id="element-6767">
            <div className="flex items-center justify-between" data-id="element-6768">
              <div className="flex items-center space-x-4" data-id="element-6769">
                <div className="w-12 h-12 rounded-xl bg-[#357BEB] bg-opacity-10 flex items-center justify-center flex-shrink-0" data-id="element-6770">
                  <topic.icon className="w-6 h-6 text-[#357BEB]" data-id="element-6771" />
                </div>
                <div data-id="element-6772">
                  <h3 className="text-lg font-bold text-[#132C53] flex items-center space-x-2" data-id="element-6773">
                    <span data-id="element-6774">{topic.id}️⃣</span>
                    <span data-id="element-6775">{topic.title}</span>
                  </h3>
                </div>
              </div>
              <motion.div animate={{
            rotate: expandedId === topic.id ? 180 : 0
          }} transition={{
            duration: 0.3
          }} data-id="element-6776">
                <ChevronDownIcon className="w-6 h-6 text-[#357BEB]" data-id="element-6777" />
              </motion.div>
            </div>
            <AnimatePresence data-id="element-6778">
              {expandedId === topic.id && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="overflow-hidden" data-id="element-6779">
                  <p className="text-gray-600 mt-4 pl-16" data-id="element-6780">
                    {topic.description}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </button>
        </motion.div>)}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }} className="mt-6 bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-r-xl" data-id="element-6781">
        <p className="text-[#132C53] font-medium" data-id="element-6782">
          🔔 Grupul nu este opțional – este un instrument de lucru. Fără
          comunicare, sistemul nu poate interveni la timp pentru a te sprijini.
        </p>
      </motion.div>
    </div>;
}